export enum ScreeningsLabelType {
  Print = 'print',
  Release = 'release'
}
